// dependencies
import { mount } from 'svelte';
import App from './App.svelte';

// polyfills
import './utils/polyfills';

// styles
import './styles/graphic.scss';

// Clear console in development
if (import.meta.env.DEV) {
  console.clear();
}

// Optionally show/hide the headline + dek (the #meta block) via a query param.
// e.g. ?meta=false (or hide/0) hides it; ?meta=true (or show/1) forces it on.
// Absent -> default (visible). Useful for home-page/card embeds.
(() => {
  const value = new URLSearchParams(window.location.search).get('meta');
  if (value === null) return;

  const metaEl = document.getElementById('meta');
  if (!metaEl) return;

  const hide = ['false', '0', 'hide', 'no'].includes(value.toLowerCase());
  metaEl.style.display = hide ? 'none' : '';
})();

// Mount the app using the Svelte 5 API
const app = mount(App, {
  target: document.getElementById('graphic'),
});

export default app;
